import * as React from 'react';
import { tokens } from 'src/design-system';

export default ({ containerDetails, airCargoPackageTypes }) => {
  if (containerDetails.length >= 2) {
    const weightKeys = containerDetails.map((container) => {
      return container.hasOwnProperty('weight') ? 'weight' : 'totalWeight';
    });
    const [
        {
          type: type1,
          count: count1,
          [weightKeys[0]]: { value: weightValue1, unit: weightUnit1 },
          volumetricWeight: { value: volWeightValue1, unit: volWeightUnit1 },
          // volume: { value: value1, unit: volUnit1 },
        },
        {
          type: type2,
          count: count2,
          [weightKeys[1]]: { value: weightValue2, unit: weightUnit2 },
          volumetricWeight: { value: volWeightValue2, unit: volWeightUnit2 },
          // volume: { value: value2, unit: unit2 },
        },
    ] = containerDetails;
    const weight1 = weightValue1 >= volWeightValue1 ? weightValue1 : volWeightValue1;
    const unitOfWeight1 = weightValue1 >= volWeightValue1 ? weightUnit1 : volWeightUnit1;
    const weight2 = weightValue2 >= volWeightValue2 ? weightValue2 : volWeightValue2;
    const unitOfWeight2 = weightValue2 >= volWeightValue2 ? weightUnit2 : volWeightUnit2;
    return (
        <>
            <div style={{ color: '#424242', fontSize: `${tokens.fontSize.caption}px`, marginBottom: '8px' }}>
                <span style={{ fontWeight: 600 }}>{count1}</span>
                &nbsp;X&nbsp;{weight1.toFixed(2)} {unitOfWeight1} (c. wt)
                &nbsp;|&nbsp;<span style={{ fontWeight: 600 }}>{airCargoPackageTypes[type1]}</span>
            </div>
            <div style={{ color: '#424242', fontSize: `${tokens.fontSize.caption}px`, marginBottom: '8px' }}>
                <span style={{ fontWeight: 600 }}>{count2}</span>
                &nbsp;X&nbsp;{weight2.toFixed(2)} {unitOfWeight2} (c. wt)
                &nbsp;|&nbsp;<span style={{ fontWeight: 600 }}>{airCargoPackageTypes[type2]}</span>
            </div>
            <div
              style={{
                textAlign: 'center',
                color: '#262626',
                fontSize: `${tokens.fontSize.caption}px`,
                fontWeight: tokens.fontWeight.semibold,
              }}>
                {
                  containerDetails.length > 2 ?
                    `+${containerDetails.length - 2} More`
                    : ''
                }
            </div>
        </>
    );
  }
  if (containerDetails.length === 1) {
    const weightKey = containerDetails[0].hasOwnProperty('weight') ? 'weight' : 'totalWeight';
    const [{
      type,
      count,
      [weightKey]: { value: weightValue, unit: weightUnit },
      volumetricWeight: { value: volWeightValue, unit: volWeightUnit },
      // volume: { volValue, volUnit },
    }] = containerDetails;
    const weight = weightValue >= volWeightValue ? weightValue : volWeightValue;
    const unitOfWeight = weightValue >= volWeightValue ? weightUnit : volWeightUnit;
    return (
        <div style={{ color: '#424242', fontSize: `${tokens.fontSize.caption}px`, marginBottom: '8px' }}>
            <span style={{ fontWeight: 600 }}>{count}</span>
            &nbsp;X&nbsp;{weight.toFixed(2)} {unitOfWeight} (c. wt)
            &nbsp;|&nbsp;<span style={{ fontWeight: 600 }}>{airCargoPackageTypes[type]}</span>
        </div>
    );
  }
  return null;
};
